import "./Find.css";
import { Link } from "react-router-dom";
const Find = () => (
  <section className="findSection" id="listings">
    <div className="findContainer">
      <div className="findHeaderDiv">
        <span className="horizontalLine"></span>
        <h1 className="findHeaderText">Find your next place to live</h1>
      </div>
      <div className="findFilterDiv">
        <div className="input">
          <select name="lookingFor" id="lookingFor">
            <option value="Test">Test</option>
            <option value="Test">Test</option>
            <option value="Test">Test</option>
          </select>
        </div>
        <div className="input">
          <select name="lookingFor" id="lookingFor">
            <option value="Test">Test</option>
            <option value="Test">Test</option>
            <option value="Test">Test</option>
          </select>
        </div>
        <div className="input">
          <select name="lookingFor" id="lookingFor">
            <option value="Test">Test</option>
            <option value="Test">Test</option>
            <option value="Test">Test</option>
          </select>
        </div>
        <div className="input lastChild">
          <select name="lookingFor" id="lookingFor">
            <option value="Test">Test</option>
            <option value="Test">Test</option>
            <option value="Test">Test</option>
          </select>
        </div>
      </div>
      <div className="findGridDiv">
        <div className="HouseDiv">
          <Link to="/house">
            <img src="./images/house.png" alt="" className="houseImg" />
            <h3 className="HouseTitle">Malto House</h3>
            <div className="icons">
              <div className="icon">
                <img src="./images/icon-room.png" alt="" /> 4
              </div>
              <div className="icon">
                <img src="./images/icon-bathroom.png" alt="" /> 4
              </div>
              <div className="icon" style={{ border: "none" }}>
                <img src="./images/icon-rating.png" alt="" /> 4
              </div>
            </div>
          </Link>
        </div>
        <div className="HouseDiv">
          <Link to="/house">
            <img src="./images/house.png" alt="" className="houseImg" />
            <h3 className="HouseTitle">Malto House</h3>
            <div className="icons">
              <div className="icon">
                <img src="./images/icon-room.png" alt="" /> 4
              </div>
              <div className="icon">
                <img src="./images/icon-bathroom.png" alt="" /> 4
              </div>
              <div className="icon" style={{ border: "none" }}>
                <img src="./images/icon-rating.png" alt="" /> 4
              </div>
            </div>
          </Link>
        </div>
        <div className="HouseDiv">
          <Link to="/house">
            <img src="./images/house.png" alt="" className="houseImg" />
            <h3 className="HouseTitle">Malto House</h3>
            <div className="icons">
              <div className="icon">
                <img src="./images/icon-room.png" alt="" /> 4
              </div>
              <div className="icon">
                <img src="./images/icon-bathroom.png" alt="" /> 4
              </div>
              <div className="icon" style={{ border: "none" }}>
                <img src="./images/icon-rating.png" alt="" /> 4
              </div>
            </div>
          </Link>
        </div>
        <div className="HouseDiv">
         <Link to="/house">
            <img src="./images/house.png" alt="" className="houseImg" />
            <h3 className="HouseTitle">Malto House</h3>
            <div className="icons">
              <div className="icon">
                <img src="./images/icon-room.png" alt="" /> 4
              </div>
              <div className="icon">
                <img src="./images/icon-bathroom.png" alt="" /> 4
              </div>
              <div className="icon" style={{ border: "none" }}>
                <img src="./images/icon-rating.png" alt="" /> 4
              </div>
            </div>
          </Link>
        </div>
        <div className="HouseDiv">
          <Link to="/house">
            <img src="./images/house.png" alt="" className="houseImg" />
            <h3 className="HouseTitle">Malto House</h3>
            <div className="icons">
              <div className="icon">
                <img src="./images/icon-room.png" alt="" /> 4
              </div>
              <div className="icon">
                <img src="./images/icon-bathroom.png" alt="" /> 4
              </div>
              <div className="icon" style={{ border: "none" }}>
                <img src="./images/icon-rating.png" alt="" /> 4
              </div>
            </div>
          </Link>
        </div>
        <div className="HouseDiv">
          <a href="/house">
            <img src="./images/house.png" alt="" className="houseImg" />
            <h3 className="HouseTitle">Malto House</h3>
            <div className="icons">
              <div className="icon">
                <img src="./images/icon-room.png" alt="" /> 4
              </div>
              <div className="icon">
                <img src="./images/icon-bathroom.png" alt="" /> 4
              </div>
              <div className="icon" style={{ border: "none" }}>
                <img src="./images/icon-rating.png" alt="" /> 4
              </div>
            </div>
          </a>
        </div>
        <div className="HouseDiv">
          <Link to="/house">
            <img src="./images/house.png" alt="" className="houseImg" />
            <h3 className="HouseTitle">Malto House</h3>
            <div className="icons">
              <div className="icon">
                <img src="./images/icon-room.png" alt="" /> 4
              </div>
              <div className="icon">
                <img src="./images/icon-bathroom.png" alt="" /> 4
              </div>
              <div className="icon" style={{ border: "none" }}>
                <img src="./images/icon-rating.png" alt="" /> 4
              </div>
            </div>
          </Link>
        </div>
        <div className="HouseDiv">
          <Link to="/house">
            <img src="./images/house.png" alt="" className="houseImg" />
            <h3 className="HouseTitle">Malto House</h3>
            <div className="icons">
              <div className="icon">
                <img src="./images/icon-room.png" alt="" /> 4
              </div>
              <div className="icon">
                <img src="./images/icon-bathroom.png" alt="" /> 4
              </div>
              <div className="icon" style={{ border: "none" }}>
                <img src="./images/icon-rating.png" alt="" /> 4
              </div>
            </div>
          </Link>
        </div>
        <div className="HouseDiv">
          <Link to="/house">
            <img src="./images/house.png" alt="" className="houseImg" />
            <h3 className="HouseTitle">Malto House</h3>
            <div className="icons">
              <div className="icon">
                <img src="./images/icon-room.png" alt="" /> 4
              </div>
              <div className="icon">
                <img src="./images/icon-bathroom.png" alt="" /> 4
              </div>
              <div className="icon" style={{ border: "none" }}>
                <img src="./images/icon-rating.png" alt="" /> 4
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  </section>
);
export default Find;
